import { Injectable } from "@angular/core";
import { Database } from './../database';
import 'rxjs/add/operator/map';

@Injectable()
export class BllKdvGruplar extends Database{
    eklenecek_kdvgruplari=[];

    constructor(){
        super("NL_KDVGrup");
    }
}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-kdvgruplari.ts